export const formatSerialNumber = (serialNumber: string | number): string => {
  if (typeof serialNumber === 'string' || typeof serialNumber === 'number') {
    return String(serialNumber).replace(/^ +/, '').replace(/^0+/, '')
  }
  return ''
}

export const validateSerialNumber = async (serialValue: string): Promise<string> => {
  if (serialValue.startsWith('0')) {
    throw new Error('WRONG_SERIAL_NUMBER')
  }

  if (/^[1-9]/.test(serialValue)) {
    if (/^[1-9]\d{4,5}$/.test(serialValue)) {
      return serialValue
    }

    throw new Error('WRONG_SERIAL_NUMBER')
  }

  if (/^[A-Z]/i.test(serialValue)) {
    if ((/^[A-Z]+\d{5,}/i.exec(serialValue)) === null) {
      throw new Error('WRONG_SERIAL_NUMBER_WITH_LETTER')
    }
  }

  return serialValue
}
